import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableComposeExperienceUrls from './tableComposeExperienceUrls';

export default {
  title: 'Sponsor',
  attributeName: 'sponsor',
  fields: [
     {
      attributeName: 'name',
      id: 'sponsor_name',  
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      required: true,
      helpText: 'Name of the sponsor.',
      errorText: '',
    },
    {
      attributeName: 'media_url_id',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Media URL',
      visibleWhen:{"field":"isLive","value":false},
      placeholder: 'Video Url...',
      mainField:"url",
      fromConfigTable: tableComposeExperienceUrls,
      popupSize:'xl',
      fieldsToUpdate:["duration","content_type"]
    },
    {
      attributeName: 'media_id',
      id: 'sponsor_media_id',
      label: 'Media',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the sponsor.',
      errorText: '',
    },
    {
      attributeName: 'organization_id',
      id: 'sponsor_organization_id',
      label: 'Organization',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the sponsor.',
      errorText: '',
    },
    {
      attributeName: 'visible',
      label: 'Visible',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Indicate if sponsors is visible',
    },
  ],
};
